import React from 'react';

import EmptySidebarIcon from 'sidebar/EmptySidebarIcon';
import {getStudySchemaListingURL} from 'studies/study-schemas/StudySchemaDAO';

import * as SidebarConstants from './SidebarConstants';
import SidebarItem from './SidebarItem';

interface StudySchemaSettingsProps {
  section: SidebarConstants.Section;
}

export default function StudySchemaSettings(props: StudySchemaSettingsProps): JSX.Element {
  return (
    <div>
      <div className="browser-nav-header">Study Schemas</div>
      <SidebarItem
        active={props.section === SidebarConstants.Section.STUDY_SCHEMAS}
        icon={<EmptySidebarIcon />}
        name="Study schemas"
        link={getStudySchemaListingURL()}
      />
    </div>
  );
}
